import React from "react";
const IconCheckmarkGradientV2 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
    <g id="Icon">
      <path
        id="Vector 410"
        d="M4.83331 9.31842L9.19695 13.0876L16.8333 6.08765"
        stroke="url(#paint0_linear_1548_5640_v2)"
        strokeWidth="2"
        strokeLinejoin="bevel"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1548_5640_v2"
        x1="4.83331"
        y1="9.58765"
        x2="16.8333"
        y2="9.58765"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DB06AD" />
        <stop offset="0.296875" stopColor="#DA0C9B" />
        <stop offset="1" stopColor="#D44102" />
      </linearGradient>
    </defs>
  </svg>
);
export default IconCheckmarkGradientV2;
